const useHandleChange =
  (initialFormState, formik) =>
  ({ target: { name, value, checked, type } }) => {
    const inputValue = type === 'checkbox' ? checked : value;

    formik.setFieldValue(name, inputValue);
  };

export default useHandleChange;
